import config from '../../../config';
import defaultDigestLinks from '../../../config/default-digest-links.json';
import { getDefaultContent } from '../../../utils';

import type { DigestHighlightItem } from '../types';

export interface GetDefaultDigestLinks {
  numExistingLinks: number;
  buildId: string;
}

const convertJsonLinksToPrismicLinks = ({
  link,
  text,
}: (typeof defaultDigestLinks)[number]) => ({
  digestLink: link,
  digestLinkText: text,
});

export function getDefaultDigestLinks({
  numExistingLinks,
  buildId,
}: GetDefaultDigestLinks): DigestHighlightItem[] {
  const numItemsToReturn =
    config.get('content.minDigestLinks') - numExistingLinks;

  if (numItemsToReturn <= 0) {
    return [];
  }

  return getDefaultContent({
    items: defaultDigestLinks,
    numItemsToReturn,
    seed: buildId,
  }).map(convertJsonLinksToPrismicLinks);
}
